import { ComposedTheme, createUseStyles } from '@glu/theming';
import '../themeDefaults';

const styles = ({ formComponents }: ComposedTheme) => ({
  dark: {},
  error: {},
  input: {
    '&$dark': {
      '&::placeholder': {
        color: formComponents.input.placeholder,
      },
      '&:focus': {
        borderColor: formComponents.input.darkFocusColor,
        outline: 'none',
      },
      backgroundColor: formComponents.input.dark.backgroundColor,
      color: formComponents.dark.color,
    },
    '&$error': {
      '&$dark': {
        '&:focus': {
          borderColor: formComponents.input.darkFocusColor,
        },
        borderColor: formComponents.dark.error.borderColor,
      },
      borderColor: formComponents.error.borderColor,
    },
    '&$textarea': {
      height: formComponents.input.textareaHeight,
    },
    '&$warning$error': {
      '&$dark': {
        '&:focus': {
          borderColor: formComponents.input.darkFocusColor,
        },
        borderColor: formComponents.dark.warning.borderColor,
      },
      borderColor: formComponents.warning.borderColor,
    },
    '&:disabled': {
      backgroundColor: '#EDEDED',
      color: formComponents.input.color,
      cursor: 'not-allowed',
      opacity: 1,
    },
    '&:focus': {
      outlineColor: formComponents.input.focusColor,
    },
    backgroundColor: formComponents.input.backgroundColor,
    border: formComponents.input.border,
    borderRadius: formComponents.input.borderRadius,
    color: formComponents.input.color,
    display: 'block',
    fontFamily: formComponents.input.fontFamily,
    fontSize: formComponents.input.fontSize,
    fontWeight: formComponents.input.fontWeight,
    height: formComponents.input.height,
    padding: formComponents.input.padding,
    width: '100%',
  },
  textarea: {},
  warning: {},
});

export default createUseStyles(styles);
